import React, { Suspense } from "react";
import { Await } from "react-router-dom";
import { ArticleContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import Spinner from "@components/Spinner/Spinner";
import { CustomContext, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import ArticleContent from "./Article/ArticleContent";

export default function DefaultPageHandler(): React.ReactElement {
  const { context }: CustomContext<ArticleContext> = useRouteContext();

  if (context && context.statusCode !== HttpStatusCode.Ok) {
    // StatusCode is not 200
    return <CustomError statusCode={context.statusCode} />;
  }

  return (
    <Suspense fallback={<Spinner />}>
      <Await resolve={context} errorElement={<CustomError />}>
        {({
          kind,
          error,
          data: {
            cook: {
              data: { context, seeAlso },
            },
            sectionNews,
            gsChannels,
          },
        }) => {
          if (error || kind !== "art") {
            // Error or kind is not "art"
            return <CustomError statusCode={context.statusCode} />;
          }

          // StatusCode is 200 and kind is "art"
          return (
            <ArticleContent
              {...{ context, sectionNews, seeAlso, gsChannels }}
            />
          );
        }}
      </Await>
    </Suspense>
  );
}
